import { get } from 'lodash';

export const getCommentDeepLinkRoutingData = state => get(state, 'deepLinkRouting.comment');
